export const SEASONAL_CHALLENGE_ALIASES = {
    COMPLETE_ONBOARDING: 'complete-onboarding',
    LAUNCH_GS: 'launch-gifting-suite',
    INVITE_FRIENDS: 'invite-friends',
    MAKE_PURCHASE: 'make-marketplace-purchase',
    EARN_POINTS: 'earn-points'
};
